


























































































import Vue from 'vue';
import { AuthService } from '@/services';

import { dialogMaxWidth } from '@/constants';

interface Data {
  dialogMaxWidth: string;
  signOutConfirm: boolean;
}

export default Vue.extend({
  name: 'UserMenu',
  data(): Data {
    return {
      dialogMaxWidth,
      signOutConfirm: false,
    };
  },
  props: {
    user: {
      type: Object as () => any,
      required: true,
    },
  },
  methods: {
    logout(): void {
      AuthService.signOutUser(true);
    },
    confirmSignOut(): void {
      this.signOutConfirm = true;
    },
  },
});
